import React from 'react';

const RealTalkSection = () => {
  const cantDoItems = [
    {
      text: "Fira tak boleh jadikan anda kaya dalam sebulan.",
      subtext: "Kalau ada yang janji macam tu, lari."
    },
    {
      text: "Fira tak boleh ganti skill anda.",
      subtext: "Tool tanpa knowledge = gambling dengan interface cantik."
    },
    {
      text: "Fira tak boleh stop anda dari buat silap.",
      subtext: "Anda manusia. Anda akan still ada bad days."
    },
    {
      text: "Fira bukan \"holy grail.\"",
      subtext: "Takde benda dalam trading yang 100%."
    }
  ];

  return (
    <section className="bg-[#191919] py-[50px] px-[25px] md:py-[75px] md:px-[75px] lg:py-[100px] lg:px-[100px]">
      <div className="max-w-4xl mx-auto">
        {/* Main Headline */}
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-[#F8F8F8] text-center mb-8 tracking-tight leading-tight">
          Apa Fira Smart Desk <span className="text-[#FF6699]">Tak Boleh</span> Buat
        </h2>

        {/* Intro */}
        <p className="text-xl md:text-2xl text-[#F8F8F8]/80 text-center mb-16 font-medium">
          Sebelum saya cerita apa yang boleh, saya nak jujur dulu.
        </p>

        {/* Can't Do List - Icon Left, Text Right Layout */}
        <div className="space-y-8">
          {cantDoItems.map((item, index) => (
            <div 
              key={index}
              className="bg-[#F8F8F8]/5 rounded-2xl p-6 md:p-8 border border-[#F8F8F8]/10 hover:border-[#FF6699]/30 transition-all duration-300"
            >
              <div className="flex flex-col md:flex-row items-center md:items-start gap-4 md:gap-8">
                {/* Icon - Centered on mobile, left on desktop */}
                <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 md:w-16 md:h-16">
                  <span className="text-3xl md:text-4xl">❌</span>
                </div>
                
                {/* Text Content - Centered on mobile, left-aligned on desktop */}
                <div className="flex-1 text-center md:text-left">
                  <p className="text-xl md:text-2xl text-[#F8F8F8] font-bold mb-2">
                    {item.text}
                  </p>
                  <p className="text-lg md:text-xl text-[#F8F8F8]/60 font-medium">
                    {item.subtext}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tapi... - Pink */}
        <div className="text-center mt-16">
          <span className="text-4xl md:text-5xl lg:text-6xl font-black text-[#FF6699]">
            Tapi...
          </span>
        </div>
      </div>
    </section>
  );
};

export default RealTalkSection;
